<template>
    <div :class="addtlClass">
        <label :for="name" v-if="label" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" :class="labelClass">{{ label }}:</label>
        <Field
            as="select"
            :name="name"
            class="bg-gray-50 h-10 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
            v-model="value"
            @change="$emit('update:modelValue', $event.target.value)"
            :rules="rules"
            :disabled="disableField"
            :autocomplete="autoComplete"
            :class="addtlInputClass"
        >
            <option v-if="none" selected value="">{{ all ? 'All' : label ? label.length > 15 ? 'Please select' : 'Select ' + label : altLabel ? altLabel : 'None' }}</option>
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="indexValue ? index.toString() : setValue ? option[setValue].toString() : option.toString()"
            >
                {{ setLabel ? option[setLabel] : option }}
            </option>
        </Field>
        <ErrorMessage :name="name" class="text-sm text-red-600 dark:text-red-300 m-1" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { Field, ErrorMessage } from 'vee-validate';

const props = defineProps({
    modelValue: {
        type: [String,Number],
        default: ""
    },
    label: {
        type: String,
        default: "",
    },
    altLabel: null,
    name: {
        type: String,
        default: "",
    },
    rules: {
        type: String,
        default: "",
    },
    options: {
        type: [Array, Object],
        default: []
    },
    disableField: {
        type: Boolean,
        default: false
    },
    autoComplete: {
        type: String,
        default: "",
    },
    setValue: {
        type: String,
        default: ""
    },
    setLabel: {
        type: String,
        default: ""
    },
    all: {
        type: Boolean,
        default: false
    },
    none: {
        type: Boolean,
        default: true
    },
    indexValue: {
        type: Boolean,
        default: false
    },
    addtlClass: {
        type: String,
        default: ""
    },
    labelClass: {
        type: String,
        default: ""
    },
    addtlInputClass: {
        type: String,
        default: ""
    }
})

const emit = defineEmits(['update:modelValue'])

const value = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})
</script>


<style scoped>

</style>
